import { render, staticRenderFns } from "./pivotOptionsObject.vue?vue&type=template&id=04de75e7&scoped=true&"
import script from "./pivotOptionsObject.vue?vue&type=script&lang=js&"
export * from "./pivotOptionsObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de75e7",
  null
  
)

export default component.exports